module.exports = __webpack_public_path__ + "static/coffee-5e3b042e834fcab6aa8bb89d37ead70b.jpg";